import Logo from '../asset/images/home/Logo (1).png';
import DashboardHome from '../asset/images/home/dashboard-home.jpg';
import Frame1 from '../asset/images/home/Frame 28994.png';
import Frame2 from '../asset/images/home/Frame 28994 (1).png';
import Frame3 from '../asset/images/home/Frame 28994 (2).png';
import Frame4 from '../asset/images/home/Frame 28994 (3).png';
import FemaleCrossArms from '../asset/images/home/female teacher crossed arms.png';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

function Home() {
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "EducationalOrganization",
        "name": "READ 21",
        "description": "Professional teacher training courses for reading instruction using the Science of Reading methodology",
        "url": "https://fasttrackreading.com",
        "logo": "https://fasttrackreading.com/logo512.png",
        "sameAs": [
            "https://www.youtube.com/@read21"
        ],
        "offers": {
            "@type": "Offer",
            "price": "650",
            "priceCurrency": "USD",
            "description": "Individual course enrollment"
        }
    };

    return (
        <>
            <SEO
                title="READ 21 - Professional Teacher Training Courses | Fast Track to Reading"
                description="Learn the Science of Reading with READ 21's online training. Comprehensive teacher training courses enabling you to effectively teach students to read in only 8 weeks. Enroll today!"
                keywords="teacher training, reading instruction, science of reading, professional development, educator courses, teacher certification, reading education, fast track to reading"
                url="/"
                structuredData={structuredData}
            />
            {/* Header */}
            <header className="bg-white shadow-md">
                <div className="max-w-7xl mx-auto px-6 py-6">
                    <div className="flex justify-between items-center">
                        {/* Logo */}
                        <div className="flex items-center">
                            <img src={Logo} alt="READ 21 Logo" className="h-16 w-auto" />
                        </div>

                        {/* Navigation */}
                        <div className="flex items-center space-x-8">
                            <Link to="/about"
                                className="bg-transparent text-gray-700 px-8 py-3 rounded-md font-medium text-lg
                                hover:bg-primaryDark hover:text-white transition-colors">
                                About
                            </Link>
                            <Link to="/login"
                                className="bg-transparent text-gray-700 px-8 py-3 rounded-md font-medium text-lg
                                    hover:bg-primaryDark hover:text-white transition-colors"
                                    >
                                Login
                            </Link>
                            <Link to="/register"
                                className="bg-transparent text-gray-700 px-8 py-3 rounded-md font-medium text-lg
                                    hover:bg-primaryDark hover:text-white transition-colors"
                                    >
                                Enroll Today
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="border-b-2"></div>
            </header>

            {/* Hero Section */}
            <section className="py-12">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                        {/* Left Content */}
                        <div>
                            <p className="text-muted text-base mb-6">
                                <span className="font-bold">Read 21:</span> Using the Science of Reading to Teach Students to Read
                                Fast!
                            </p>
                            <h1 className="text-5xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
                                Learn the Science of Reading with Read 21's Online Training
                            </h1>
                            <p className="text-lg text-muted leading-relaxed">
                                This online course will provide you with essential training in the Science of Reading, using Read 21's
                                methodology, enabling you to effectively teach students to read in only 8 weeks.
                            </p>
                        </div>

                        {/* Right Image */}
                        <div className="flex justify-center">
                            <div>
                                <img
                                    src={DashboardHome}
                                    alt="Teacher reading with students"
                                    className="max-w-full h-auto rounded-lg"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="border-b-2 mt-5"></div>
                </div>
            </section>

            {/* Training Courses */}
            <section className="py-10">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center mb-5">
                        <h2 className="text-3xl md:text-3xl text-primary">Our Training Courses</h2>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {/* Course 1 */}
                        <div>
                            <div className="mb-4">
                                <img src={Frame1} alt="Fast Track Course" className="mx-auto h-28 w-auto" />
                            </div>
                            <h3 className="text-md font-bold text-primary mb-3 text-center">
                                Fast Track to Reading
                            </h3>
                            <center>
                                <Link to="/about">
                                    <button className="bg-gradient-to-b from-[#439D55] to-[#6bc77e] text-white py-3 px-12 rounded-xl font-bold hover:from-green-500 hover:to-green-700 transition-all duration-200 shadow-xl">
                                        Visit Course
                                    </button>
                                </Link>
                            </center>
                        </div>

                        {/* Course 2 */}
                        <div className="opacity-50 grayscale">
                            <div className="mb-4">
                                <img
                                    src={Frame2}
                                    alt="Online Web App"
                                    className="mx-auto h-28 w-auto"
                                />
                            </div>
                            <h3 className="text-md font-bold text-primary mb-3 text-center">
                                Read 21's Online Web <br /> App
                            </h3>
                            <center>
                                <button 
                                    disabled
                                    className="bg-gray-400 text-white py-3 px-12 rounded-xl font-bold cursor-not-allowed opacity-50">
                                    Visit Course
                                </button>
                            </center>
                        </div>

                        {/* Course 3 */}
                        <div className="opacity-50 grayscale">
                            <div className="mb-4">
                                <img src={Frame3} alt="Teacher Portal" className="mx-auto h-28 w-auto" />
                            </div>
                            <h3 className="text-md font-bold text-primary mb-3 text-center">
                                Understanding the <br /> Teacher Portal
                            </h3>
                            <center>
                                <button 
                                    disabled
                                    className="bg-gray-400 text-white py-3 px-12 rounded-xl font-bold cursor-not-allowed opacity-50">
                                    Visit Course
                                </button>
                            </center>
                        </div>

                        {/* Course 4 */}
                        <div className="opacity-50 grayscale">
                            <div className="mb-4">
                                <img src={Frame4} alt="Parent Portal" className="mx-auto h-28 w-auto" />
                            </div>
                            <h3 className="text-md font-bold text-primary mb-3 text-center">
                                Understanding the <br /> Parent Portal
                            </h3>
                            <center>
                                <button 
                                    disabled
                                    className="bg-gray-400 text-white py-3 px-12 rounded-xl font-bold cursor-not-allowed opacity-50">
                                    Visit Course
                                </button>
                            </center>
                        </div>
                    </div>
                </div>
            </section>

            {/* Engage Section */}
            <section className="py-10">
                <div className="max-w-7xl mx-auto">
                    <div className="bg-white border-2 border-primary rounded-xl pt-10 shadow-lg">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                            {/* Left Image */}
                            <div className="flex justify-center">
                                <img
                                    src={FemaleCrossArms}
                                    alt="Virtual Teacher"
                                    className="max-w-full h-auto rounded-lg"
                                />
                            </div>

                            {/* Right Content */}
                            <div className="p-3">
                                <p className="text-muted text-base mb-6">
                                    <span className="font-bold">Read 21:</span> Using the Science of Reading to Teach Students to Read
                                    Fast!
                                </p>
                                <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
                                    Engage with virtual Teachers and Students in a dynamic learning environment.
                                </h2>
                                <p className="text-xl text-muted leading-relaxed">
                                Discover the Science of Reading while learning an effective strategy to elevate your reading skills within this 5-hour course. Enroll today to begin your journey!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-primary py-10">
                <div className="max-w-7xl mx-auto px-6 text-center">
                    <div className="mb-3">
                        <img src={Logo} alt="READ 21 Logo" className="mx-auto h-16 w-auto" />
                    </div>
                    <p className="text-white text-lg">Read 21 © 2025 - All Rights Reserved</p>
                </div>
            </footer>

        </>
    );
}

export default Home;